/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getTagsRealtimeData } from '../fn/real-time-data/get-tags-realtime-data';
import { GetTagsRealtimeData$Params } from '../fn/real-time-data/get-tags-realtime-data';
import { TagsRealtimeData } from '../models/tags-realtime-data';


/**
 * All about real time data
 */
@Injectable({ providedIn: 'root' })
export class RealTimeDataService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTagsRealtimeData()` */
  static readonly GetTagsRealtimeDataPath = '/tags/realtime';

  /**
   * Get realtime data for the given tags.
   *
   * The station uid must be provided for each tag name. If a tag name exists in several connections (opcua...) of a station, it raises an error
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTagsRealtimeData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTagsRealtimeData$Response(params: GetTagsRealtimeData$Params, context?: HttpContext): Observable<StrictHttpResponse<TagsRealtimeData>> {
    return getTagsRealtimeData(this.http, this.rootUrl, params, context);
  }

  /**
   * Get realtime data for the given tags.
   *
   * The station uid must be provided for each tag name. If a tag name exists in several connections (opcua...) of a station, it raises an error
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTagsRealtimeData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTagsRealtimeData(params: GetTagsRealtimeData$Params, context?: HttpContext): Observable<TagsRealtimeData> {
    return this.getTagsRealtimeData$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagsRealtimeData>): TagsRealtimeData => r.body)
    );
  }

}
